import { Pipe, PipeTransform } from '@angular/core';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { environment } from 'src/environment';

@Pipe({
  name: 'questionTitle',
  standalone: true
})
export class QuestionTitlePipe implements PipeTransform {

  transform(question?: Question): unknown {

    if(question?.titleToData)
      return question?.titleToData;
    if (question?.type?.id == EQuestionType.Autocomplete || question?.type?.id == EQuestionType.Mark || question?.type?.id == EQuestionType.Multi) {
      if (question?.title != null && question?.title != "")
        return question?.title;
      else {
        if (question?.optionsList?.name != null && question?.optionsList?.name != "")
          return question?.optionsList?.name;
        else {
          if (question?.optionsList?.name != null && question?.optionsList?.name != "") {
            return question?.optionsList?.name;
          } else {
            environment.lang === "he" ? "בחירת אפשרות" : "Choose Option";
          }
        }
      }
    }
    if (question?.title != undefined && question?.title != "")
      return question?.title;
    else
      return question?.text ?? ((environment.lang === "he") ? "אין טקסט שאלה" : "there is not question text");
  }
}
